import * as t from 'io-ts'
import { DateFromISOString } from 'io-ts-types'
import { nullable } from 'lib/request'

export const TGenerateAPIKeyResponse = t.strict({
  apiKey: t.string,
})

export const TAPIKey = t.strict({
  apiKey: nullable(
    t.strict({
      createdAt: DateFromISOString,
    }),
  ),
  userId: t.string,
})

export const TCLIReleaseDate = nullable(
  t.strict({
    link: t.string,
    title: t.string,
    version: t.string,
    createdAt: DateFromISOString,
  }),
)

export const TUserSettings = t.strict({
  pinAIControls: t.boolean,
})

export type UserSettings = t.TypeOf<typeof TUserSettings>
